/**
 * Modulo de Aplicacoes: o registry de SSO da plataforma.
 *
 * Nao confundir com o Catalogo (`modules/catalogo`): la e o vocabulario de
 * permissao (Service/Feature/Action); aqui e o cadastro que faz uma
 * aplicacao existir para o SSO -- slug, icone, URLs por empresa/ambiente e as
 * APIs com que ela pode falar. Sem uma entrada aqui, a plataforma nao tem para
 * onde mandar o usuario.
 */
export const nav = {
    permissao: 'accounts.aplicacoes:ver',
    section: 'Resources',
    title: 'Applications',
    icon: 'apps',
    route: '/aplicacoes',
    accordion: false,
};

export default [
    {
        path: '/aplicacoes',
        name: '/aplicacoes',
        component: () => import('./pages/AplicacoesListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.aplicacoes:ver' },
    },
    {
        path: '/aplicacoes/nova',
        name: 'aplicacao-registro-nova',
        component: () => import('./pages/AplicacaoPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.aplicacoes:criar' },
    },
    {
        path: '/aplicacoes/editar/:id',
        name: 'aplicacao-registro-editar',
        component: () => import('./pages/AplicacaoPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'accounts.aplicacoes:editar' },
    },
];
